export default "__VITE_ASSET__0019ab15__"